import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getBezierPath,
} from "@xyflow/react";
import { Badge } from "@/components/ui/badge";
import type { EdgeState, AdvancedEdgeData } from "@/types/edgeTypes";

export interface EdgeLabel {
  text: string;
  position: "start" | "middle" | "end";
  color?: string;
  configurable?: boolean;
}

export const LabeledEdge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
  selected,
}: EdgeProps & { data?: AdvancedEdgeData }) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const labels = data?.labels || [];
  const state = data?.state;

  const handleLabelClick = (label: EdgeLabel) => {
    if (label.configurable) {
      // Open configuration dialog
      console.log("Configure edge label:", label);
    }
  };

  const renderLabel = (label: EdgeLabel, index: number) => {
    let x = labelX;
    let y = labelY;

    // Position labels based on their position setting
    if (label.position === "start") {
      x = sourceX + (labelX - sourceX) * 0.2;
      y = sourceY + (labelY - sourceY) * 0.2;
    } else if (label.position === "end") {
      x = targetX + (labelX - targetX) * 0.2;
      y = targetY + (labelY - targetY) * 0.2;
    }

    return (
      <div
        key={index}
        className="absolute transform -translate-x-1/2 -translate-y-1/2 pointer-events-auto"
        style={{ left: x, top: y }}
      >
        <Badge
          variant={state?.active ? "default" : "secondary"}
          className={`cursor-pointer ${label.configurable ? "hover:bg-primary/20" : ""}`}
          onClick={() => handleLabelClick(label)}
          style={{ backgroundColor: label.color }}
        >
          {label.text}
        </Badge>
      </div>
    );
  };

  return (
    <>
      <BaseEdge 
        path={edgePath} 
        markerEnd={markerEnd} 
        style={{
          ...style,
          stroke: state?.active ? "#10b981" : (selected ? "#3b82f6" : "#64748b"),
          strokeWidth: state?.active ? 3 : (selected ? 2 : 1),
        }} 
      />
      <EdgeLabelRenderer>
        {labels.map(renderLabel)}
        {state && (
          <div
            className="absolute transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
            style={{ left: labelX + 20, top: labelY - 20 }}
          >
            <div className="text-xs text-muted-foreground bg-background px-1 rounded">
              {state.executionCount}x
            </div>
          </div>
        )}
      </EdgeLabelRenderer>
    </>
  );
};
